import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';

import FormGroupArray from '../../services/FormGroupArray';
@Injectable({ providedIn: 'root' })
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  FR_VALUES = ['FRA', 'FR', 'France', 'fr', 'fra', 'france'];

  generateForm(entity: any, option: any): UntypedFormGroup {
    const { hasSwisslifeProduct = false } = option || {};

    let formBuilderGroup = this.formBuilder.group({
      ownerId: [entity.ownerId],
      taxResidence: [entity?.taxResidence || null, Validators?.required],
      dateNonResidenceFiscaleEnFrance: [
        entity?.dateNonResidenceFiscaleEnFrance || null,
        hasSwisslifeProduct &&
        entity?.taxResidence &&
        !this.FR_VALUES.includes(entity.taxResidence)
          ? Validators.required
          : Validators.nullValidator,
      ],
    });

    return formBuilderGroup;
  }

  generate(entity: any, option) {
    const { products = [] } = entity;
    const hasSwisslifeProduct = products?.some(
      ({ parameters }) => parameters?.partnerFlux === 'SWISSLIFE',
    );
    return FormGroupArray.generate({
      entity,
      options: {
        ...(option ? option : {}),
        hasSwisslifeProduct,
      },
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    const formValue = _.cloneDeep(this.form.value.owners);
    formValue.forEach((owner: any) => {
      if (!this.FR_VALUES.includes(owner.taxResidence)) {
        owner.dateNonResidenceFiscaleEnFrance =
          owner.dateNonResidenceFiscaleEnFrance;
      } else {
        owner.dateNonResidenceFiscaleEnFrance = null;
      }
    });

    return formValue;
  }
}
